import { render, staticRenderFns } from "./BoughtSmallCard.vue?vue&type=template&id=d364c822&scoped=true"
import script from "./BoughtSmallCard.vue?vue&type=script&lang=ts"
export * from "./BoughtSmallCard.vue?vue&type=script&lang=ts"
import style0 from "./BoughtSmallCard.vue?vue&type=style&index=0&id=d364c822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d364c822",
  null
  
)

export default component.exports